import { Link } from 'react-router-dom';
import AnimatedSection from '../../../components/base/AnimatedSection';

export default function CTASection() {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-600 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <AnimatedSection animation="scale">
          <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-3xl p-6 sm:p-10 md:p-16 border border-cyan-500/30 shadow-2xl shadow-cyan-500/20 text-center">
            <div className="inline-flex items-center gap-2 px-5 py-2 bg-cyan-500/10 backdrop-blur-sm rounded-full text-cyan-400 mb-6 sm:mb-8 border border-cyan-500/30">
              <i className="ri-rocket-line"></i>
              <span className="text-sm font-semibold">开始使用</span>
            </div>

            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
              准备好开始了吗？
            </h2>
            
            <p className="text-sm sm:text-xl text-gray-300 mb-8 sm:mb-12 max-w-2xl mx-auto leading-relaxed">
              基于 AI Agent 的岗位型 AI 员工平台，如果您有商业需求，欢迎联系我们雇佣你的第一个 AI 员工
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
              <Link
                to="/quick-start"
                className="w-full sm:w-auto group px-8 sm:px-10 py-4 sm:py-5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-xl hover:from-cyan-600 hover:to-blue-700 transition-all shadow-xl shadow-cyan-500/40 hover:shadow-2xl hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer flex items-center justify-center gap-3 font-bold text-base sm:text-lg hover:scale-105"
              >
                立即开始
                <i className="ri-arrow-right-line text-xl sm:text-2xl group-hover:translate-x-1 transition-transform"></i>
              </Link>
              
              <a
                href="https://goclaw.group/zh-CN/"
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-slate-800 text-cyan-400 rounded-xl hover:bg-slate-700 transition-all whitespace-nowrap cursor-pointer font-bold text-base sm:text-lg border border-cyan-500/30 hover:border-cyan-500/50 flex items-center justify-center gap-2 hover:scale-105"
              >
                访问 GoClaw
                <i className="ri-external-link-line text-xl"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-slate-700">
              {[
                { icon: 'ri-github-fill', text: '开源免费', link: 'https://github.com/openclaw/openclaw' },
                { icon: 'ri-community-line', text: '活跃社区' },
                { icon: 'ri-customer-service-line', text: '专业支持' },
              ].map((item) => (
                item.link ? (
                  <a
                    key={item.text}
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                  >
                    <i className={`${item.icon} text-cyan-400 text-xl`}></i>
                    <span className="text-sm font-medium">{item.text}</span>
                  </a>
                ) : (
                  <div 
                    key={item.text}
                    className="flex items-center gap-2 text-gray-400"
                  >
                    <i className={`${item.icon} text-cyan-400 text-xl`}></i>
                    <span className="text-sm font-medium">{item.text}</span>
                  </div>
                )
              ))}
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}